<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="p-card-field1">
        <div class="p-field p-grid">
          <label class="p-col-fixed"><strong>Type <span class="color">*</span></strong></label>
        </div>
      </div>
      <div class="p-card-field1">
        <div class="p-field p-grid">
          <Dropdown style="border-radius: unset" id="type" class="p-col-width border_color text-area" v-model="SelectedType" :options="type" optionLabel="name" optionValue="value" placeholder="Choose" />
        </div>
        <input class="input_tmp_validator" id="vali_type">
      </div>

      <div class="p-card-field1">
        <div class="p-field p-grid">
          <label class="p-col-fixed"><strong>Reason (EN) <span class="color">*</span></strong></label>
        </div>
      </div>
      <div class="p-card-field1">
        <div class="p-field p-grid">
          <Textarea :autoResize="true"  rows="1" maxlength="255" v-model="reason.name_en"  id="name_en" type="text" class="p-col-width border_color text-area" placeholder="Input " />
        </div>
      </div>

      <div class="p-card-field1">
        <div class="p-field p-grid">
          <label class="p-col-fixed"><strong>Reason (KR) <span class="color">*</span></strong></label>
        </div>
      </div>
      <div class="p-card-field1">
        <div class="p-field p-grid">
          <Textarea :autoResize="true"  rows="1" maxlength="255" v-model="reason.name_ko"  id="name_ko" type="text" class="p-col-width border_color text-area" placeholder="Input " />
        </div>
      </div>

      <div class="p-card-field1">
        <div class="p-field p-grid">
          <label class="p-col-fixed"><strong>Reason (VN) <span class="color">*</span></strong></label>
        </div>
      </div>
      <div class="p-card-field1">
        <div class="p-field p-grid">
          <Textarea :autoResize="true"  rows="1" maxlength="255" v-model="reason.name_vi"  id="name_vi" type="text" class="p-col-width border_color text-area" placeholder="Input " />
        </div>
      </div>

      <div class="p-card-field1">
        <div class="p-field p-grid">
          <label class="p-col-fixed "><strong>Rank <span class="color">*</span></strong></label>
        </div>
      </div>
      <div class="p-card-field1">
        <div class="p-field p-grid">
          <InputNumber :min="0" :max="100000" v-model="reason.rank" id="rank"  type="text" placeholder="Input"  class="p-col-width input_distance text-area"/>
        </div>
        <input class="input_tmp_validator" id="validator_rank">
      </div>

      <div class="p-card-field div_check">
        <div class="p-col checkbox">
          <Checkbox  v-model="reason.active" :binary="true"/>
          <label class="p-col-fixed txt-right text">Show</label>
        </div>
      </div>

      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
                    <Button
                        label="Cancel"
                        @click="backToList()"
                        class="p-button-warning cancel"
                        style="width: 120px !important;"
                    />
          <Button
              v-if="mode == 'edit'"
              :label="'Save'"
              @click="saveData()"
              class="p-button-success save"
              style="width: 120px !important;"

          />
           <Button
            v-else
            :label="'Save'"
            @click="saveData()"
            class="p-button-success save"
            style="width: 120px !important;"

          />
        </template>
      </Toolbar>
    </div>

  </form>
</template>

<script>
import DataServices from '@/core/DataServices'
// import CkeditorCode from '../CkeditorCode';
export default {
  // components: {
  //   CkeditorCode
  // },
  props: {
    mode: String,
    model: Object,
    users: Array
  },
  data() {
    return {
      policy_content:'', 
      content_en: '',
      content_ko: '',
      content_vi: '',
      content_key: 0,
      title: '',
      ordinal: 1,
      validationErrors: {},
      formMode: this.mode,
      firebaseID: null,
      userID: null,
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      reason: {
        name_en:'',
        name_ko:'',
        name_vi:'',
        rank:'',
        active:true
      },
      SelectedType: '',
      type: [
        {name: 'Report user', value: 'REPORT_USER'},
        {name: 'Report post', value: 'REPORT_POST'},
        // {name: 'Report other', value:  'REPORT_OTHER'},
      ],
      images: [],
      imagesDeletes: [],
      imgDelete : [],
      maxFileSize: 1000000, // 1MB
      maxFiles: 1,
      saving:false,
    }
  },
  async mounted() {
    console.log("modelll",this.model)
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      console.log("this.model*****************",this.model)
      this.reason.active = this.model.active
      this.reason.rank = this.model.rank
      this.SelectedType = this.model.type
      console.log("trtrtrtr",this.SelectedType)

      var reason_id = this.model.id

      var gqLQueryList = DataServices.getList('report_reason_lang');
      console.log("gqL",gqLQueryList)
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: {report_reason_id :{_eq: reason_id}},
        }
      });

      var listData = resData.data['report_reason_lang'];
      console.log("listData11",listData)

      for (var i = 0 ; i < listData.length ; i++){
        if (listData[i].lang == "en"){
          this.reason.name_en = listData[i].name
        }
        else if (listData[i].lang == "ko"){
          this.reason.name_ko = listData[i].name
        }
        else if (listData[i].lang == "vi"){
          this.reason.name_vi = listData[i].name
        }
      }
    }
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.EDIT_POLICY);
    this.role.edit = (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) ? false:true;

    // var that =this;
    //   if(this.model.relationship_file && this.model.relationship_file.length > 0){
    //     for (let i = 0; i < this.model.relationship_file.length; i++) {
    //       const e = this.model.relationship_file[i];
    //       if(e.type == 'POLICY'){
    //         if (e.file && e.file.url) {
    //           let url = e.file.url
    //           let split = url.split('/')
    //           let fileName = split[split.length - 1]
    //           let obj = {'name': fileName, 'file': '', 'objectURL': url,type:'old_edit'}//type:'old_edit' nếu gặp type này ko update avatar
    //           this.images.push(obj)
    //         }
    //       }
    //     }
    //   }

  },
  methods: {
    backToList() {
      this.$emit('back');
    },
    async validateData() {


      let type = document.getElementById("vali_type");
      console.log("type",type)
      if (this.$commonFuction.isEmptyObject(this.SelectedType)){
        console.log("type11",type)
        type.setCustomValidity("Please choose the type");
      }else {
        type.setCustomValidity("");
      }

      let name_en = document.getElementById("name_en");
      if (this.reason.name_en == undefined || this.reason.name_en == null || this.reason.name_en == ''){
        console.log("type1133",name_en)
        name_en.setCustomValidity(" Please enter the reason");
      }else {
        name_en.setCustomValidity("");
      }
      let name_ko = document.getElementById("name_ko");
      if (this.reason.name_ko == undefined || this.reason.name_ko == null || this.reason.name_ko == ''){
        name_ko.setCustomValidity(" Please enter the reason");
      }else {
        name_ko.setCustomValidity("");
      }
      let name_vi = document.getElementById("name_vi");
      if (this.reason.name_vi == undefined || this.reason.name_vi == null || this.reason.name_vi == ''){
        name_vi.setCustomValidity(" Please enter the reason");
      }else {
        name_vi.setCustomValidity("");
      }
      let rank = document.getElementById("rank");
      if (this.reason.rank == undefined || this.reason.rank == null || this.reason.rank == ''){
        rank.setCustomValidity("Please enter the Rank");
      }else {
        rank.setCustomValidity("");
      }
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()){
        console.log('test=====================');
        inpObj.reportValidity();
        return true;
      }
    },
    async saveData() {
      // this.$commonFuction.is_loading(true);
       if (await this.validateData()) {
        // this.saving = false;
       // this.$commonFuction.is_loading(false);
        return
      }
      if(Object.entries(this.validationErrors).length === 0){
        var params = {
          type: this.SelectedType,
          name_en: this.reason.name_en,
          name_ko: this.reason.name_ko,
          name_vi: this.reason.name_vi,
          rank: this.reason.rank,
          active: this.reason.active,

        }
        console.log("savedata",params)
        this.$emit('save', params);
      }
      else{
        this.$commonFuction.is_loading(false);
      }
    }, 
    isImage(file) {
      return /^image\//.test(file.type);
    },
    async onFileSelect(event) {
      let files = event.target.files || event.dataTransfer.files;
      if(files.length > 0) {
        let acceptTags = ['jpeg', 'jpg', 'gif', 'png', 'JPEG', 'JPG', 'PNG', 'GIF']
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split('.').pop())) {
            alert("Vui lòng upload file ảnh có định dạng sau: jpeg, jpg, gif, png");
            return;
          }
        }
        if (files.length + this.images.length > this.maxFiles) {
          alert("Hình ảnh quá số lượng tối đa là " + this.maxFiles + " hình");
        } else {
          var arrTemp = [], arrFiles = [];
          for (let file of files) {
            if (this.isImage(file) && file.size <= this.maxFileSize) {
              file.source = file;
              file.objectURL = window.URL.createObjectURL(file);
              arrTemp.push(file);
            }
            if (file.size > this.maxFileSize) arrFiles.push(file);
          }
          
          if (arrFiles.length > 0) {
            alert("Hình ảnh của bạn đã quá dung lượng 1MB");
          } else {
            if (this.images.length > 0 && this.images[0].file === '') {
              this.imagesDeletes.push(this.images[0])
            }
            // this.images = [];
            this.images = this.images.concat.apply(this.images, arrTemp);
            // console.log(this.images)
            // await this.validateData()
          }
        }
      }
    },
    onFileClear(index) {
      let img = this.images[index];
      this.images.splice(index, 1);
      if (img.file === '') {
        this.imgDelete.push(img)
      }
    }
  },
  apollo: {
    
  }
}
</script>

<style lang="scss">
  .p-invalid {
    color: red;
    margin: 1px 0px 0px 0px;
  }
  .p-multiselect {
    width: 450px;
  }
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: .25rem;
    padding-bottom: .25rem;
    
  }
  .category-item-value {
    padding: .25rem .5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: .2rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
  .p-multiselect-label-container{
    height: 40px;
  }
  .p-invalid {
    color: red;
    margin: 1px 0px 0px 0px;
  }
  .text-active{
    margin: 0px 0px 0px 8px;
  }
  .p-formgrid >.p-card-field1 >.p-field >.p-col-width1 >.p-dropdown-panel{
    left : 0px !important
  }
  .p-col-width1 {
    width: 100%;
  }

  .save{
    background-color: #E73725!important;
    border: 1px solid #E73725!important;
  }
  .cancel{
    border: 1px solid #E73725!important;
    color: #E73725!important;
  }
  .text-area{
    width: 50%!important;
    border: 1px solid #00000029;
  }
  .p-field{
    margin-bottom: 0px!important;
  }
  .p-col-fixed{
    margin-top: 12px!important;
    padding: 0px!important;
  }
  .color{
    color: red!important;
  }
  .p-formgrid .p-card-field {
    padding: 0px!important;
  }
  .p-col{
    padding: 0px!important;
  }
  .p-checkbox .p-checkbox-box.p-highlight{
    border-color: #E73725!important;
    background: #E73725!important;
  }
  .text{
    margin-left: 12px!important;
  }
  .div_check{
    display: flex!important;
  }
  .checkbox{
    display: flex!important;
  }
  .p-checkbox-box{
    margin-top: 12px!important;
  }
  .p-card-field1{
    margin-left: 5px!important;
  }
  #rank{
    border: 1px solid #F3F4F7!important;
  }

  </style>
